import { render, staticRenderFns } from "./ConstructionEdit.vue?vue&type=template&id=2272a4c6&"
import script from "./ConstructionEdit.vue?vue&type=script&lang=ts&"
export * from "./ConstructionEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports